<template>
  <div>
    <h3>Lista wybranych produktów</h3>
    <ul class="goods-list">
      <li v-for="(product, index) in products" :key="'sm'+index">
        <b-button class="delete" title="usuń produkt" @click="$emit('remove', product)">
          <i class="fas fa-times"></i>
        </b-button>
        <p>{{product.name}}</p>
        <div class="amount">
          <b-button @click="$emit('increment', product)">
            <i class="fas fa-plus-square"></i>
          </b-button>
          <b-form-input
            :value="product.quantity"
            :formatter="formatNumber"
            @blur="rounding($event,product)"
            type="text"
          ></b-form-input>
          <b-button @click="$emit('decrement', product)">
            <i class="fas fa-minus-square"></i>
          </b-button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { numberFormat } from "@/services/helpers";

export default {
  props: {
    products: Array
  },
  methods: {
    formatNumber: numberFormat,
    rounding: function($event, product) {
      let value = $event.target.value - product.quantity;
      if (value === 0) {
        let tmp = $event.target.value;
        product.quantity -= 1;
        this.$nextTick(function() {
          product.quantity = tmp;
        });
      } else {
        this.$emit("setInput", product, value);
      }
    }
  }
};
</script>
